import React, { useState, useEffect } from 'react';
import _ from 'lodash';

import Secured from 'Secured';

const Tags = Secured(({
	request,
	label,
	name,
	tags,
	error,
	onChange
}) => {
// Cache search's data
	const [search, setSearch] = useState('');

	// Cahce active result
	const [active, setActive] = useState(0);

	// Cache visibile state
	const [visible, setVisible] = useState(false);

	// Cache request progress
	const [, setProgress] = useState(false);

	// Cache request results
	const [results, setResults] = useState([]);

	// Handles autocomplete's onChange event
	// @event: object | onChange event
	const handleChange = event => {
		const { value } = event.target;
		setSearch(value);
	};

	// Handles autocomplete result's tag onClick event
	// @idx: number | result's index
	const handleSelect = idx => {
		// Update state to parent's component
		onChange({
			name,
			value: [
				...tags,
				results[idx]
			]
		});

		setSearch('');
	};

	// Handles autocomplete's onKeyDown event
	// @event: object | onKeyDown event
	const handleKeyDown = event => {
		if (event.keyCode === 13) {
			// Prevent form from submitting
			event.preventDefault();

			// Do not add existing tag
			if (_.find(tags, ['name', search])) return;

			if (results.length) {
				// Update state to parent's component
				onChange({
					name,
					value: [
						...tags,
						results[active]
					]
				});
			} else {
				// Update state to parent's component
				onChange({
					name,
					value: [
						...tags,
						{ name: search }
					]
				});
			}

			// Reset search value
			setSearch('');
		} else if (event.keyCode === 38) {
			event.preventDefault();

			setActive(a => a === 0
				? results.length - 1
				: a - 1
			);
		} else if (event.keyCode === 40) {
			event.preventDefault();

			setActive(a => a === results.length - 1
				? 0
				: a + 1
			);
		}
	};

	// Handle tag search on search's value change
	useEffect(() => {
		// Create request parameters
		const parameters = {
			'name:likeLower': `%${search}%`
		};

		// Do not perform search
		if (search.length < 2) return setVisible(false);

		// Set request progress state
		setProgress(true);

		// Collect tags
		request('get', 'tags', parameters, null, res => {
			// Reset request progress state
			setProgress(false);

			// Update result's state
			if (res.error) return console.log('Implement error');

			// Update visibility state
			setVisible(res.length ? true : false);

			// Update results
			setResults(res);
		});
	}, [request, search]);

	return (
		<div className="form__element">
			{/* Render label only if it has been passed */}
			{label && <label className="form__label">{label}</label>}

			<div className="tags">
				{/* Display selected tags */}
				{tags.map((tag, idx) =>
					<span key={idx} className="tags__tag">
						{tag.name}
					</span>
				)}

				{/* Tag's autocomple */}
				<div className="tags__autocomplete">
					<input
						name={name}
						value={search}
						onChange={handleChange}
						onKeyDown={handleKeyDown}
					/>

					{/* Autocomplete's results */}
					{visible &&
								<div className="tags__autocompleteResults">
									{results.map((tag, idx) =>
										<span
											key={tag.id}
											onClick={() => handleSelect(idx)}
											className={idx === active
												? 'tags__autocompleteTag tags__autocompleteTag--active'
												: 'tags__autocompleteTag'
											}
										>
											{tag.name}
										</span>
									)}
								</div>
					}
				</div>
			</div>

			{/* Render error only if it has been passed */}
			{error &&<div className="form__error">{error}</div>}
		</div>
	);
});

export default Tags;
